module.exports = __webpack_public_path__ + "static/media/12-MarioSuna.858e82d3.png";